export default "__VITE_ASSET__BBfvU1mj__"